<template>
  <v-container class="pt-8 px-14 rounded elevation-4 search-area">
    <v-row align="top">
      <v-col cols="12" md="7">
        <TextField
          prepend-inner-icon="mdi-magnify"
          hint="Please enter a search term"
          :searchTerm="searchText" @update-search="updateSearchText"
          label="Search"
          :value="searchTerm"
           @input="$emit('update-search', $event)"
          :error-messages="searchError"
          clearable
          dense
          :show-success="false"
        />
      </v-col>

      <v-col cols="12" md="3">
      
      </v-col>

      <v-col cols="12" md="2" class="d-flex justify-end">
        <v-btn
          @click.prevent="onSubmit"
          color="primary lighten-5"
          class="search-button"
          >{{ $t('SearchMsg') }}</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TextField from '@/components/inputs/TextField.vue'
import AutoComplete from '@/components/inputs/AutoComplete.vue'

export default {
  props:{
    searchTerm:String,
  },
  components: {
    TextField,
    AutoComplete
  },
  data() {
    return {
      searchError: '',
      searchText: ""
    }
  },
  created(){
        this.searchText = this.$route.query?.searchTerm
    },
  methods: {
    updateSearchText(newText) {
            this.searchText = newText;
        },
    onSubmit() {
      // Reset error messages
      this.searchError = ''

      // Check if fields are filled and set error messages if needed
      if (!this.searchTerm) {
        this.searchError = 'Search term is required'
      }

      // If there are no errors, proceed with form submission
      if (!this.searchError) {
        console.log('Form Submitted')
      }
    }
  }
}
</script>

<style scoped>
.search-area {
  background-color: #f5f5f5;
}

.search-button {
  margin-bottom: 30px;
}
</style>
